import { Callout } from "@octopusdeploy/design-system-components";
import React from "react";
import { useProjectContext } from "~/areas/projects/context";
import { SkeletonLoadingLayout } from "~/components/SkeletonLoadingLayout/SkeletonLoadingLayout";
import { TemplatedProjectParameters, type TemplatedProjectParametersLoaderData } from "./TemplatedProjectParameters";
export interface TemplatedProjectParametersPageProps {
    spaceId: string;
    projectSlug: string;
    loaderData: TemplatedProjectParametersLoaderData;
}
export function TemplatedProjectParametersPage({ spaceId, projectSlug, loaderData }: TemplatedProjectParametersPageProps) {
    const projectContext = useProjectContext();
    const project = projectContext.state.model;
    if (!project) {
        return <SkeletonLoadingLayout errors={[]}/>;
    }
    if (!project.ProjectTemplateDetails?.Slug) {
        return (<Callout title="No Template Parameters" type="information">
                <div>This project is not created from a template and does not have template parameters.</div>
            </Callout>);
    }
    return <TemplatedProjectParameters loaderData={loaderData}/>;
}
